// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
import { NextEditorPluginAI } from './aiPlugin';

const aiPlugin = NextEditorPluginAI;
export { aiPlugin };

export type { AIPlugin, AIPluginOptions } from './aiPluginType';
